import {AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ErrorService} from '../services/error.service';
import {UtilService} from '../services/util.service';

@Directive({
  selector: '[SbBookingStatus]',
  standalone: false,
})
export class SbBookingStatusDirective implements AfterViewInit, OnChanges {
  @Input('SbBookingStatus') data: any;
  @Input() mode = 'default';
  @Input() dataType = 'campaign';

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    public errorHandler: ErrorService,
    public util: UtilService,
    public translate: TranslateService
  ) {}

  ngOnChanges(): void {
    this.ngAfterViewInit();
  }

  setElementRendering() {
    // No Commercials?
    if (this.dataType === 'campaign') {
      if (!this.data?.commercials || this.data?.commercials.length < 1) {
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.noCommercials'), 'grey');
        return;
      }
    }

    if (this.dataType === 'commercial') {
      // No Requirements?
      if (!this.data?.requirements || this.data.requirements.length < 1) {
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.noRequirements'), 'grey');
        return;
      }
    }

    // null object reference, therefore JSON.parse and stringify need to happen
    let bookingStatus = JSON.parse(JSON.stringify(this.data.bookingStatus));
    if (bookingStatus.hasOwnProperty('Present')) {
      bookingStatus = bookingStatus.Present;
    }
    const dataRuntime = this.util.getTimeframeValue(this.data.from, this.data.till);

    // Completely rejected?
    if (Object.keys(bookingStatus).length === 1 && bookingStatus.hasOwnProperty('Rejected')) {
      this.setStatusInfo(this.translate.instant('lang.bookingStatus.noRequirements'), 'red');
      return;
    }

    // Not running yet
    if (dataRuntime <= 0) {
      // All Active?
      if (Object.keys(bookingStatus).length === 1 && bookingStatus.hasOwnProperty('Active')) {
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.ready'), 'green');
        return;
      } else {
        // Then its pending
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.pending'), 'grey');
        return;
      }
    } else if (dataRuntime > 0 && dataRuntime < 1) {
      // All Active?
      if (Object.keys(bookingStatus).length === 1 && bookingStatus.hasOwnProperty('Active')) {
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.running'), 'green');
        return;
      } else if (!bookingStatus.hasOwnProperty('Active')) {
        // No active bookings?
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.noActiveBookings'), 'yellow');
        return;
      } else {
        // Then its partially running
        this.setStatusInfo(this.translate.instant('lang.bookingStatus.partiallyRunning'), 'yellow');
        return;
      }
    } else {
      // Completed
      this.setStatusInfo(this.translate.instant('lang.bookingStatus.inThePast'), 'blue');
      return;
    }
  }

  ngAfterViewInit() {
    if (this.dataType) {
      this.setElementRendering();
      this.translate.onDefaultLangChange.subscribe(() => {
        this.setElementRendering();
      });
    }
  }

  setStatusInfo(status: string, className: string) {
    if (this.mode === 'default') {
      this.el.nativeElement.innerHTML = status;
      this.el.nativeElement.classList = 'badge ' + className;
    }
    if (this.mode === 'progressBar') {
      const div = this.el.nativeElement.querySelector('.progress-bar');
      if (div) {
        div.classList = 'progress-bar ' + className + '-bg';
      }
    }
  }
}
